export default "__VITE_ASSET__c49c1e57__"